import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProductDefaultProperty } from "../../redux/slices/productsSlice";
import { fetchProductListBasedOnSubCategory, removeProductOrProjectFromFavorites, searchAndFilterProductItems, addToProductOrProjectToFavorites, removeProductFromCart, addProductToCart, clearFilteredProducts, filteredProductsa } from "../../redux/slices/client/clientProductSlice";
import { useNavigate } from 'react-router-dom';
// Demo images
import tshirt from '../../assets/images/cat-fashion.jpg';
import homeHero from '../../assets/images/F&A.jpg';
import StickyCategoryCouponWidget from '../../components/common/widgets/StickyCategoryCouponWidget';

const ProductShimmer = () => {
  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col items-center h-full animate-pulse">
      <div className="relative w-40 h-40 rounded-full overflow-hidden mb-4 bg-gray-200"></div>
      <div className="h-6 w-3/4 bg-gray-200 rounded mb-3"></div>
      <div className="h-5 w-1/2 bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-1/3 bg-gray-200 rounded mb-4"></div>
      <div className="w-full space-y-2 mt-2">
        <div className="h-9 bg-gray-200 rounded-md"></div>
        <div className="h-9 bg-gray-200 rounded-md"></div>
        <div className="h-9 bg-gray-200 rounded-md"></div>
      </div>
    </div>
  );
};

const FilterShimmer = () => {
  return (
    <aside className="w-full md:w-1/4 bg-white p-4 border border-gray-200 rounded-lg shadow-sm animate-pulse">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="mb-6 pb-4 border-b border-gray-100 last:border-0">
          <div className="h-5 w-3/4 bg-gray-200 rounded mb-3"></div>
          <div className="space-y-2">
            {[...Array(5)].map((_, j) => (
              <div key={j} className="h-4 bg-gray-200 rounded w-full"></div>
            ))}
          </div>
        </div>
      ))}
      <div className="h-10 bg-gray-200 rounded-md"></div>
    </aside>
  );
};



const ProductCard = ({ product, toggleFavorite, toggleCart, customLogo, user }) => {
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate();

  let categoryId = product.category.id;
  let categoryName = product.category.name;
  let subCategoryId = product.sub_category.id;
  let subCategoryName = product.sub_category.name;

  const pathToNavigateToPass = [
    {
      'name': 'Home',
      'path': '/'
    },
    {
      'name': categoryName,
      'path': `/category/${categoryId}`
    },
    {
      'name': subCategoryName,
      'path': `/category/${categoryId}/detail/${subCategoryId}`
    },

  ];
  return (
    <div className="relative bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition flex flex-col items-center h-full">
      {/* Favorite and Cart icons */}
      {/* <div className={`absolute top-4 left-4 cursor-pointer ${product.is_favorite ? 'text-red-500' : 'text-gray-400 hover:text-red-500'}  ${product.stock <= 0 ? 'pointer-events-none opacity-50' : ''}`} onClick={() => toggleFavorite(product, product.is_favorite)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3.172 5.172a4.004 4.004 0 015.656 0L10 6.343l1.172-1.171a4.004 4.004 0 015.656 5.656l-6.364 6.364a.999.999 0 01-1.414 0L3.172 10.828a4 4 0 010-5.656z" />
        </svg>
      </div> */}

      <div 
  className={`absolute top-4 right-4 cursor-pointer ${
    !user 
      ? 'text-gray-300 cursor-not-allowed' 
      : product.is_in_cart 
        ? 'text-gray-600' 
        : 'text-gray-400 hover:text-gray-600'
  } ${
    product.stock <= 0 ? 'pointer-events-none opacity-50' : ''
  }`} 
  onClick={() => user && toggleCart(product, product.is_in_cart)}
  title={!user ? "Login required" : "Add to cart"}
>
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
    <path d="M16 6h-2a4 4 0 00-8 0H4a2 2 0 00-2 2v7a4 4 0 004 4h8a4 4 0 004-4V8a2 2 0 00-2-2zm-5-1a2 2 0 114 0h-4z" />
  </svg>
</div>


      <div 
  className={`absolute top-4 left-4 cursor-pointer ${
    !user 
      ? 'text-gray-300 cursor-not-allowed' 
      : product.is_favorite 
        ? 'text-red-500' 
        : 'text-gray-400 hover:text-red-500'
  } ${
    product.stock <= 0 ? 'pointer-events-none opacity-50' : ''
  }`} 
  onClick={() => user && toggleFavorite(product, product.is_favorite)}
  title={!user ? "Login required" : "Add to favorites"}
>
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
    <path d="M3.172 5.172a4.004 4.004 0 015.656 0L10 6.343l1.172-1.171a4.004 4.004 0 015.656 5.656l-6.364 6.364a.999.999 0 01-1.414 0L3.172 10.828a4 4 0 010-5.656z" />
  </svg>
</div>

      {/* <div className={`absolute top-4 right-4 cursor-pointer ${product.is_in_cart ? 'text-gray-600' : 'text-gray-400 hover:text-gray-600'}  ${product.stock <= 0 ? 'pointer-events-none opacity-50' : ''}`} onClick={() => toggleCart(product, product.is_in_cart)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
          <path d="M16 6h-2a4 4 0 00-8 0H4a2 2 0 00-2 2v7a4 4 0 004 4h8a4 4 0 004-4V8a2 2 0 00-2-2zm-5-1a2 2 0 114 0h-4z" />
        </svg>
      </div> */}

      {/* Product Image */}
      <div className="relative w-40 h-40 rounded-full overflow-hidden mb-4 flex items-center justify-center">
        <img
          src={product.template.media_files[0]?.front_image || tshirt}
          alt={product.product_name}
          className="w-full h-full object-cover"
          onError={(e) => { e.target.src = tshirt; }}
        />
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none">
          {customLogo ? (
            <img
              src={customLogo}
              alt="Custom Logo"
              className="max-w-[80px] max-h-[80px] object-contain"
            />
          ) : (
            <div className="w-20 h-20 border-2 border-dashed border-gray-300 flex items-center justify-center">
              <span className="text-xs text-gray-500">Your Logo</span>
            </div>
          )}
        </div>
      </div>

      {/* Product Info */}
      <h3 className="text-xl font-bold text-gray-800 mb-1 text-center">{product.product_name}</h3>
      <p className="text-lg font-semibold text-gray-900 mb-2">${product.price}</p>
      <p className={`text-sm mb-2 ${product.stock > 0 ? 'text-green-600' : 'text-red-600'}`}>
        {product.stock > 0 ? 'In Stock' : 'Out of Stock'}
      </p>
      <p className="text-sm text-gray-700 mb-1 min-h-[20px]">
        <span className="font-semibold">Colors:</span>{' '}
        {product.available_colors.length > 0 ? (
          <span className="inline-flex items-center gap-1">
            {product.available_colors.map((col, idx) => (
              <span
                key={idx}
                className={`w-3 h-3 rounded-full inline-block ${getColorClass(col)}`}
                title={col.replace(/_/g, ' ')}
              ></span>
            ))}
          </span>
        ) : (
          <span className="text-gray-400">-</span>
        )}
      </p>
      <p className="text-sm text-gray-700 mb-1 min-h-[20px]">
        <span className="font-semibold">Sizes:</span>{' '}
        {product.available_sizes.length > 0 ? (
          product.available_sizes.join(', ')
        ) : (
          <span className="text-gray-400">-</span>
        )}
      </p>

      {/* Action Buttons */}
      <div className="flex flex-col w-full space-y-2 mt-2">
        <button onClick={() => setShowDetails(true)} className="border border-blue-600 text-blue-600 font-medium rounded-md py-2 hover:bg-blue-50 text-sm">
          View Details
        </button>
        <button className={`font-medium rounded-md py-2 text-sm ${product.stock <= 1 ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`} disabled={product.stock <= 0} onClick={() => navigate(`/design/${product.sub_category.id}`, { state: pathToNavigateToPass })}>
          Customize & Order
        </button>
        <button className={`font-semibold rounded-md py-2 text-sm ${product.stock <= 1 ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-gradient-to-r from-[#FFD100] to-[#FFA500] text-black hover:opacity-90'}`} disabled={product.stock <= 0} onClick={() => navigate(`/checkout/${product.id}/false`, { state: pathToNavigateToPass })}>
          Purchase Now
        </button>
      </div>

      {/* Details Overlay */}
      {showDetails && (
        <div className="absolute inset-0 bg-white rounded-2xl p-6 z-10 shadow-lg overflow-y-auto">
          <button onClick={() => setShowDetails(false)} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <h3 className="text-xl font-bold text-gray-800 mb-4">{product.product_name}</h3>
          <div className="space-y-3">
            {product.available_fabric_materials.length > 0 && (
              <p className="text-sm text-gray-700"><strong>Materials:</strong> {product.available_fabric_materials.join(', ')}</p>
            )}
            {product.available_printing_methods.length > 0 && (
              <p className="text-sm text-gray-700"><strong>Print Methods:</strong> {product.available_printing_methods.map(m => m.replace(/_/g, ' ')).join(', ')}</p>
            )}
            {product.customization_options.length > 0 && (
              <p className="text-sm text-gray-700"><strong>Customization:</strong> {product.customization_options.map(o => o.replace(/_/g, ' ')).join(', ')}</p>
            )}
            {product.orientation_options.length > 0 && (
              <p className="text-sm text-gray-700"><strong>Orientation:</strong> {product.orientation_options.map(o => o.replace(/_/g, ' ')).join(', ')}</p>
            )}
            {product.corners.length > 0 && (
              <p className="text-sm text-gray-700"><strong>Corners:</strong> {product.corners.map(c => c.replace(/_/g, ' ')).join(', ')}</p>
            )}
            <p className="text-sm text-gray-700"><strong>Category:</strong> {product.category.name}</p>
            <p className="text-sm text-gray-700"><strong>Subcategory:</strong> {product.sub_category.name}</p>
          </div>
          <div className="mt-4 flex flex-col space-y-2">
            <button className={`font-medium rounded-md py-2 text-sm ${product.stock <= 1 ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`} disabled={product.stock <= 0} onClick={() => navigate(`/design/${product.sub_category.id}`, { state: pathToNavigateToPass })}>

              Customize & Order
            </button>
            <button className={`font-semibold rounded-md py-2 text-sm ${product.stock <= 1 ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-gradient-to-r from-[#FFD100] to-[#FFA500] text-black hover:opacity-90'}`} disabled={product.stock <= 0} onClick={() => navigate(`/checkout/${product.id}/false`, { state: pathToNavigateToPass })}>

              Purchase Now
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const getColorClass = (color) => {
  const colorMap = {
    RED: 'bg-red-500',
    BLUE: 'bg-blue-500',
    GREEN: 'bg-green-500',
    BLACK: 'bg-black',
    WHITE: 'bg-white border border-gray-300',
    YELLOW: 'bg-yellow-500',
    ORANGE: 'bg-orange-500',
    PURPLE: 'bg-purple-500',
    PINK: 'bg-pink-500',
    BROWN: 'bg-amber-800',
    GREY: 'bg-gray-500',
    SILVER: 'bg-gray-300',
    GOLD: 'bg-yellow-400',
    BEIGE: 'bg-amber-100',
    NAVY: 'bg-blue-800',
    TEAL: 'bg-teal-500',
    MAROON: 'bg-red-800',
    LIME: 'bg-lime-500',
    OLIVE: 'bg-green-700',
  };
  return colorMap[color] || 'bg-gray-500';
};

const getCategoryAndSubcategoryName = (categories, subCategoryId) => {
  const category = categories.find(cat => cat.subcategories.some(sub => sub.id == subCategoryId));
  if (!category) return { categoryId: null, categoryName: null, subCategoryId: null, subCategoryName: null };

  const subCategory = category.subcategories.find(sub => sub.id == subCategoryId);
  return {
    categoryId: category.id,
    categoryName: category.name,
    subcategoryId: subCategory?.id || null,
    subCategoryName: subCategory?.name || null,
  };
};

const FilterSidebar = ({
  productDefaultProperties,
  selectedFilters,
  onCheckboxChange,
  onPriceRangeChange,
  onApplyFilters,
  onSearchTermChange,
  onClearFilters,
  onLogoUpload,
  customLogo
}) => {
  const formatFilterLabel = (key) => {
    return key
      .replace('product_', '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  };

  const getColorClass = (color) => {
    const colorMap = {
      RED: 'bg-red-500',
      BLUE: 'bg-blue-500',
      GREEN: 'bg-green-500',
      BLACK: 'bg-black',
      WHITE: 'bg-white border border-gray-300',
      YELLOW: 'bg-yellow-500',
      ORANGE: 'bg-orange-500',
      PURPLE: 'bg-purple-500',
      PINK: 'bg-pink-500',
      BROWN: 'bg-amber-800',
      GREY: 'bg-gray-500',
      SILVER: 'bg-gray-300',
      GOLD: 'bg-yellow-400',
      BEIGE: 'bg-amber-100',
      NAVY: 'bg-blue-800',
      TEAL: 'bg-teal-500',
      MAROON: 'bg-red-800',
      LIME: 'bg-lime-500',
      OLIVE: 'bg-green-700',
    };
    return colorMap[color] || 'bg-gray-500';
  };

  const shouldUseGridLayout = (key) => {
    const gridKeys = ['product_sizes', 'product_colors'];
    return gridKeys.includes(key);
  };

  const isChecked = (filterKey, value) => {
    const filterMap = {
      product_colors: 'colors',
      product_sizes: 'sizes',
      product_fabric_materials: 'fabric_materials',
      product_printing_methods: 'printing_methods',
      product_customization_options: 'customization_options',
      product_orientation_options: 'orientation_options',
      product_corners: 'corners',
      product_status: 'status'
    };
    const backendKey = filterMap[filterKey];
    return selectedFilters[backendKey]?.includes(value) || false;
  };

  const fileInputRef = useRef(null);

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        onLogoUpload(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClearLogo = (e) => {
    e.stopPropagation(); // Prevent triggering the file input
    onLogoUpload(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Clear the file input
    }
  };

  return (
    <aside className="w-full md:w-1/4 bg-white p-4 border border-gray-200 rounded-lg shadow-sm">
      {/* Search Input */}
      <div className="mb-6">
        <h3 className="text-md font-bold text-[#0B0C52] mb-3">Add Your Logo</h3>
        <div
          className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:bg-gray-50 relative"
          onClick={() => !customLogo && fileInputRef.current.click()}
        >
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleLogoUpload}
            accept="image/*"
            className="hidden"
          />

          {customLogo ? (
            <>
              <div className="relative">
                <img
                  src={customLogo}
                  alt="Uploaded logo"
                  className="max-h-40 mx-auto object-contain"
                />
                <button
                  onClick={handleClearLogo}
                  className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-md hover:bg-gray-100"
                  title="Remove logo"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
              <p className="text-sm text-gray-600 mt-2">Click to change logo</p>
            </>
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <p className="text-sm text-gray-600 mt-2">Click to upload your logo</p>
              <p className="text-xs text-gray-400">PNG, JPG up to 2MB</p>
            </>
          )}
        </div>
      </div>

      <div className="mb-6">
        <h3 className="text-md font-bold text-[#0B0C52] mb-3">Search</h3>
        <input
          type="text"
          value={selectedFilters.search_term}
          onChange={onSearchTermChange}
          placeholder="Search products..."
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B0C52]"
        />
      </div>

      {/* Filter sections */}
      {productDefaultProperties && Object.entries(productDefaultProperties).map(([key, values]) => (
        <div key={key} className="mb-6 pb-4 border-b border-gray-100 last:border-0">
          <h3 className="text-md font-bold text-[#0B0C52] mb-3">{formatFilterLabel(key)}</h3>
          {shouldUseGridLayout(key) ? (
            <div className="grid grid-cols-3 gap-1">
              {values.map(value => (
                <label key={value} className="flex flex-col items-center text-xs text-gray-700 hover:text-[#0B0C52] cursor-pointer">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      checked={isChecked(key, value)}
                      onChange={onCheckboxChange(key, value)}
                      className="form-checkbox h-3 w-3 text-[#0B0C52] border-gray-300 rounded focus:ring-[#0B0C52]"
                    />
                    {key === 'product_colors' && (
                      <span
                        className={`w-4 h-4 rounded-full ml-1 ${getColorClass(value)} border border-gray-200`}
                        title={value.replace(/_/g, ' ')}
                      />
                    )}
                  </div>
                  <span className="text-center mt-1">{value.replace(/_/g, ' ')}</span>
                </label>
              ))}
            </div>
          ) : (
            <div className="space-y-2">
              {values.map(value => (
                <label key={value} className="flex items-center text-sm text-gray-700 hover:text-[#0B0C52] cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isChecked(key, value)}
                    onChange={onCheckboxChange(key, value)}
                    className="form-checkbox h-3 w-3 text-[#0B0C52] border-gray-300 rounded focus:ring-[#0B0C52]"
                  />
                  <span className="ml-2 flex items-center">
                    {key === 'product_colors' && (
                      <span
                        className={`w-4 h-4 rounded-full mr-1 ${getColorClass(value)} border border-gray-200`}
                        title={value.replace(/_/g, ' ')}
                      />
                    )}
                    {value.replace(/_/g, ' ')}
                  </span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* Price Range */}
      <div className="mb-6">
        <h3 className="text-md font-bold text-[#0B0C52] mb-3">Price Range</h3>
        <div className="px-2">
          <input
            type="range"
            min="0"
            max="1000"
            value={selectedFilters.price_max}
            onChange={(e) => onPriceRangeChange(Number(e.target.value))}
            className="w-full h-2 bg-[#0B0C52] bg-opacity-20 rounded-lg appearance cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-[#0B0C52]"
          />
          <div className="flex justify-between text-sm text-gray-600 mt-2">
            <span>$0</span>
            <span className="font-medium text-[#0B0C52]">${selectedFilters.price_max}</span>
            <span>$1000+</span>
          </div>
        </div>
      </div>

      {/* Apply Filters button */}
      <button
        onClick={onApplyFilters}
        className="w-full bg-[#0B0C52] hover:bg-[#0a0a45] text-white font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out"
      >
        Apply Filters
      </button>
      <button
        onClick={onClearFilters}
        className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out mt-2"
      >
        Clear Filters
      </button>
    </aside>
  );
};

const ProductCategoriesDetail = () => {
  const { subCategoryId } = useParams();
  const dispatch = useDispatch();
  const { productDefaultProperties } = useSelector((state) => state.products);
  const { categories } = useSelector((state) => state.home);
  const { loadingSubCategory, errorSubCategory, ListOfProductsDetail, filteredProducts } = useSelector((state) => state.productByCategory);
  const { user, token } = useSelector((state) => state.auth);
  const { categoryId, categoryName, _, subCategoryName } = getCategoryAndSubcategoryName(categories, subCategoryId);
  const [customLogo, setCustomLogo] = useState(null);


  const handleLogoUpload = (logoData) => {
    setCustomLogo(logoData);
  };

  useEffect(() => {
    dispatch(getAllProductDefaultProperty());
    dispatch(fetchProductListBasedOnSubCategory(subCategoryId));
  }, [dispatch, subCategoryId]);

  const clearFilters = () => {
    setSelectedFilters({
      search_term: '',
      category_id: categoryId,
      sub_category_id: subCategoryId,
      price_min: 0,
      price_max: 1000,
      colors: [],
      sizes: [],
      fabric_materials: [],
      printing_methods: [],
      customization_options: [],
      orientation_options: [],
      corners: [],
      status: []
    });
    dispatch(clearFilteredProducts()); // This will clear the filtered products in the state
  };

  const [selectedFilters, setSelectedFilters] = useState({
    search_term: '',
    category_id: categoryId,
    sub_category_id: subCategoryId,
    price_min: 0,
    price_max: 1000,
    colors: [],
    sizes: [],
    fabric_materials: [],
    printing_methods: [],
    customization_options: [],
    orientation_options: [],
    corners: [],
    status: []
  });

  const handleCheckboxChange = (filterKey, value) => (e) => {
    const filterMap = {
      product_colors: 'colors',
      product_sizes: 'sizes',
      product_fabric_materials: 'fabric_materials',
      product_printing_methods: 'printing_methods',
      product_customization_options: 'customization_options',
      product_orientation_options: 'orientation_options',
      product_corners: 'corners',
      product_status: 'status'
    };

    const backendKey = filterMap[filterKey];
    const currentValues = selectedFilters[backendKey] || [];

    if (e.target.checked) {
      setSelectedFilters(prev => ({
        ...prev,
        [backendKey]: [...currentValues, value]
      }));
    } else {
      setSelectedFilters(prev => ({
        ...prev,
        [backendKey]: currentValues.filter(v => v !== value)
      }));
    }
  };

  const toggleFavorite = (product, currentStatus) => {
    if (currentStatus) {
      dispatch(removeProductOrProjectFromFavorites(product.id));
    } else {
      dispatch(addToProductOrProjectToFavorites({ item_id: product.id, type: 'product' }));
    }
  };

  const toggleCart = (product, currentStatus) => {
    if (currentStatus) {
      dispatch(removeProductFromCart(product.id));
    } else {
      dispatch(addProductToCart({ item_id: product.id, type: 'product' }));
    }
  };

  const handlePriceRangeChange = (value) => {
    setSelectedFilters(prev => ({
      ...prev,
      price_max: value
    }));
  };

  const handleSearchTermChange = (e) => {
    setSelectedFilters(prev => ({
      ...prev,
      search_term: e.target.value
    }));
  };

  const handleApplyFilters = () => {
    const filterData = {
      ...selectedFilters,
      colors: selectedFilters.colors.join(','),
      sizes: selectedFilters.sizes.join(','),
      fabric_materials: selectedFilters.fabric_materials.join(','),
      printing_methods: selectedFilters.printing_methods.join(','),
      customization_options: selectedFilters.customization_options.join(','),
      orientation_options: selectedFilters.orientation_options.join(','),
      corners: selectedFilters.corners.join(','),
      status: selectedFilters.status.join(',')
    };

    // Remove empty values
    Object.keys(filterData).forEach(key => {
      if (filterData[key] === null ||
        filterData[key] === '' ||
        filterData[key] === undefined ||
        (Array.isArray(filterData[key]) && filterData[key].length === 0)) {
        delete filterData[key];
      }
    });
    // Dispatch your filtered products fetch action here
    dispatch(searchAndFilterProductItems(filterData));
  };

  return (
    <div className="bg-[#EEE8E8] min-h-screen pb-12">
      {/* Hero Section */}
      <div className="min-h-[70vh] bg-cover bg-center flex flex-col justify-center items-center text-center py-16 px-5" style={{ backgroundImage: `url(${homeHero})` }}>
        <h1 className="text-white font-bold text-6xl md:text-[100px] mb-6">Hoodies &amp; Sweatshirts</h1>
        <button className="bg-[#FFD100] text-black font-semibold text-sm py-2 px-6 border border-gray-500 rounded hover:bg-[#FFCA00]">
          Start Designing
        </button>
      </div>

      {/* Breadcrumb */}
      <div className="bg-[#00148c] w-full px-4 pt-6 text-sm text-white">
        <nav>
          <Link to="/" className="hover:underline">Home</Link>
          <span className="mx-2">/</span>
          <Link to={`/category/${categoryId}`} className="hover:underline">{categoryName}</Link>
          <span className="mx-2">/</span>
          <span className="font-medium text-[#FFD700]">{subCategoryName}</span>
        </nav>
      </div>

      {/* Main Content */}
      <div className="max-w-screen-xl mx-auto px-4 mt-4">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Hoodies &amp; Sweatshirts</h2>

        <div className="flex flex-col md:flex-row gap-6">
          {/* Filter Sidebar */}
          {loadingSubCategory || !productDefaultProperties ? (
            <FilterShimmer />
          ) : (
            <FilterSidebar
              productDefaultProperties={productDefaultProperties}
              selectedFilters={selectedFilters}
              onCheckboxChange={handleCheckboxChange}
              onPriceRangeChange={handlePriceRangeChange}
              onApplyFilters={handleApplyFilters}
              onSearchTermChange={handleSearchTermChange}
              onClearFilters={clearFilters}
              onLogoUpload={handleLogoUpload}
              customLogo={customLogo} // Add this line
            />
          )}

          {/* Product List */}
          {/* Product List */}
          <section className="w-full md:w-3/4">
            {loadingSubCategory ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[...Array(6)].map((_, i) => (
                  <ProductShimmer key={i} />
                ))}
              </div>
            ) : filteredProducts === null ? ( // Check for null first
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {ListOfProductsDetail.map((product) => (
                  <ProductCard key={product.id} product={product} toggleFavorite={toggleFavorite} toggleCart={toggleCart} customLogo={customLogo}  user={user}/>
                ))}
              </div>
            ) : filteredProducts.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredProducts.map((product) => (
                  <ProductCard key={product.id} product={product} toggleFavorite={toggleFavorite} toggleCart={toggleCart} customLogo={customLogo} user={user}/>
                ))}
              </div>
            ) : (
              <div className="bg-white p-8 rounded-lg shadow-sm text-center col-span-3">
                <p className="text-gray-600 text-lg">No products match your filters.</p>
                <button
                  onClick={clearFilters}
                  className="mt-4 inline-block bg-blue-600 text-white font-medium rounded-md py-2 px-4 hover:bg-blue-700 text-sm"
                >
                  Clear Filters
                </button>
              </div>
            )}
          </section>
        </div>
      </div>
      <StickyCategoryCouponWidget 
  categoryId={categoryId} 
  categoryName={categoryName} 
/>
    </div>
  );
};

export default ProductCategoriesDetail;